export enum SkeletonTypes {
  TITLE = "title",
  DESCRIPTION = "description",
  AVATAR = "avatar",
  LABEL = "label",
}
